import { MobiDocument } from './MobiDocument';

export class GroupeIndividu extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private intitule : string;
    private initiales : string;
    private obsolete : boolean;

    public constructor(groupe : any){
        super()
        this._id = groupe._id;
        this._rev = groupe._rev;
        this.id = groupe.id;
        this.intitule = groupe.intitule;
        this.initiales = groupe.initiales;
        this.obsolete = groupe.obsolete;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getintitule(): string {
        return this.intitule;
    }

    public setintitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getInitiales(): string {
        return this.initiales;
    }

    public setInitiales(initiales: string): void {
        this.initiales = initiales;
    }

    public isObsolete(): boolean {
        return this.obsolete;
    }

    public setObsolete(obsolete: boolean): void {
        this.obsolete = obsolete;
    }

}